import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

// The dark "… · Undo" message a team-wide action leaves (shown by showUndoToast).
export const UndoToast = ({
  message,
  onUndo,
  closeToast
}: {
  message: string;
  onUndo: () => void;
  closeToast: () => void;
}) => (
  <div className="flex items-center gap-4 text-sm font-medium text-white">
    <span>{message}</span>
    <button
      type="button"
      className="font-bold text-primary-400 hover:text-primary-300"
      onClick={() => {
        onUndo();
        closeToast();
      }}
    >
      Undo
    </button>
    <button
      type="button"
      aria-label="Dismiss"
      className="flex size-5 items-center justify-center text-white/60 hover:text-white"
      onClick={closeToast}
    >
      <HugeiconsIcon icon={Cancel01Icon} size={16} />
    </button>
  </div>
);
